"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countPendingReviews = countPendingReviews;
function countPendingReviews(items) {
    return (items !== null && items !== void 0 ? items : []).filter((r) => r.status === 'PENDING').length;
}
